import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const createSongs = createAsyncThunk("createSongs", async (data) => {
    const response = await API.post('song/create', data);
    return response.data;
});

export const getSongs = createAsyncThunk("getSongs", async ({ page, limit, search }) => {
    const response = await API.get('song/list', {
        params: { page, limit, search }
    });
    return response.data;
});

export const createLocation = createAsyncThunk("createLocation", async (data) => {
    const response = await API.post('location/create', data);
    return response.data;
});

export const getLocations = createAsyncThunk("getLocations", async () => {
    const response = await API.get('location/list');
    return response.data;
});
export const editLocation = createAsyncThunk("editLocation", async (payload) => {
    const response = await API.put('location/update', payload);
    return response.data;
});
export const deleteLocation = createAsyncThunk("deleteLocation", async ({ id }) => {
    const response = await API.delete('location/delete', {
        params: { id }
    });
    return response.data;
});

export const editSong = createAsyncThunk("editSong", async (data) => {
    const response = await API.put('song/edit', data);
    return response.data;
});
export const deleteSong = createAsyncThunk("deleteSong", async ({ id }) => {
    const response = await API.delete('song/delete', {
        params: { id }
    });
    return response.data;
});
